module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/icon-custom-merch-6385760181c555660d04fc5364a44ba9.svg";